import Vue from 'vue'
import App from './App.vue'
import store from './store'
import "@/design/index.scss";
import "@/helpers";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css' // Import stylesheet
import vClickOutside from 'v-click-outside'
import i18n from './i18n'

Vue.use(vClickOutside)
Vue.component('multiselect', Multiselect)
Vue.config.productionTip = false
Vue.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f);
            }
        }
        window.addEventListener('scroll', f);
    }
});

new Vue({
    store,
    i18n,
    render: h => h(App)
}).$mount('#PrefabCreator')
